module.exports = __webpack_public_path__ + "img/nav-logout-off.37133689.png";